var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReelfollowerchart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7154_32152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0244 0.5H2.97563C1.33303 0.501906 0.00190625 1.83303 0 3.47563V13.5244C0.00190625 15.167 1.33303 16.4981 2.97563 16.5H13.0244C14.667 16.4981 15.9981 15.167 16 13.5244V3.47563C15.9981 1.83303 14.667 0.501906 13.0244 0.5ZM14.8955 3.47563V4.44034H12.0974L10.0047 1.60453H13.0244C14.0573 1.60569 14.8943 2.44272 14.8955 3.47563ZM8.63194 1.60453L10.7246 4.44034H7.36806L5.27537 1.60453H8.63194ZM1.10453 3.47563C1.10569 2.44275 1.94272 1.60572 2.97563 1.60453H3.90266L5.99534 4.44034H1.10453V3.47563ZM13.0244 15.3955H2.97563C1.94275 15.3943 1.10572 14.5573 1.10453 13.5244V5.54491H14.8955V13.5244C14.8943 14.5573 14.0573 15.3943 13.0244 15.3955Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9437 9.99117L6.5745 7.46861C6.31034 7.31611 5.97259 7.40661 5.82009 7.67077C5.77162 7.75474 5.74609 7.84995 5.74609 7.94692V12.9921C5.74609 13.2971 5.99334 13.5444 6.29834 13.5444C6.39528 13.5444 6.49053 13.5189 6.5745 13.4704L10.9437 10.9478C11.2079 10.7953 11.2984 10.4575 11.1459 10.1934C11.0974 10.1094 11.0277 10.0396 10.9437 9.99117ZM6.85063 12.0355V8.90345L9.56306 10.4695L6.85063 12.0355Z",
    fill: "#656565"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7154_32152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReelfollowerchart);
export default __webpack_public_path__ + "static/media/reel follower chart.14c1c64bbac941e6bece988c4783bee8.svg";
export { ForwardRef as ReactComponent };